import { checkauth } from '../Helper';

const Report = () => import('../views/report/Report.vue');

export default [
	{
		path: '/report',
		name: 'report',
		component: Report,
		beforeEnter(to, from, next) {
			checkauth().then(response => {
				if (response) {
					next();
				} else {
					next('/login');
				}
			});
		},
	},
];
